export default "__VITE_ASSET__Du_IYTba__"